export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_CW_BANCA_BM-8178895cee35ffafb0bd276779731106.pdf";